import { HeroFloorPlan } from "@/components/HeroFloorPlan";

const CORNER_BRACKET = ({ x, y, flipX = false, flipY = false }) => {
    const sx = flipX ? -1 : 1;
    const sy = flipY ? -1 : 1;
    return (
        <g transform={`translate(${x} ${y}) scale(${sx} ${sy})`}>
            <path d="M 0 20 L 0 0 L 20 0" fill="none" stroke="#FDB927" strokeWidth="1.25" strokeOpacity="0.55" />
        </g>
    );
};

/** Option 3 — Split Canvas: clean text zone + dedicated visual panel */
export const HeroBackgroundSplit = () => (
    <>
        <div className="pointer-events-none absolute inset-0 bg-white" />
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_70%_55%_at_18%_42%,rgba(244,248,247,0.9)_0%,transparent_70%)]" />

        {/* Desktop — right visual panel */}
        <div
            className="pointer-events-none absolute inset-y-0 right-0 hidden w-[min(50%,720px)] lg:block"
            style={{ clipPath: "polygon(14% 0, 100% 0, 100% 100%, 0 100%)" }}
            data-testid="hero-split-panel-desktop"
        >
            <div className="absolute inset-0 bg-gradient-to-br from-brand-surface via-brand-mist/90 to-brand-teal/[0.07]" />
            <div className="bg-blueprint-hero absolute inset-0 opacity-75" />
            <div className="bg-blueprint-hero-major absolute inset-0 opacity-65" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_70%_at_72%_45%,rgba(253,185,39,0.1)_0%,transparent_62%)]" />

            <img
                src="/showcase/living.webp"
                alt=""
                className="absolute inset-0 h-full w-full object-cover opacity-[0.1] blur-2xl"
            />

            <svg className="absolute inset-0 h-full w-full" viewBox="0 0 720 900" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                <path
                    d="M 80 120 C 180 280, 260 360, 380 480 S 580 680, 640 780"
                    fill="none"
                    stroke="rgba(6,78,87,0.12)"
                    strokeWidth="3"
                    strokeLinecap="round"
                />
                <path
                    d="M 80 120 C 180 280, 260 360, 380 480 S 580 680, 640 780"
                    fill="none"
                    stroke="#FDB927"
                    strokeWidth="2"
                    strokeOpacity="0.45"
                    strokeLinecap="round"
                    strokeDasharray="0.5 16"
                />
                <CORNER_BRACKET x={48} y={48} />
                <CORNER_BRACKET x={672} y={48} flipX />
                <CORNER_BRACKET x={48} y={852} flipY />
                <CORNER_BRACKET x={672} y={852} flipX flipY />
            </svg>

            <HeroFloorPlan variant="panel" />
        </div>

        {/* Desktop — diagonal gold seam */}
        <svg
            className="pointer-events-none absolute inset-0 hidden h-full w-full lg:block"
            viewBox="0 0 1440 900"
            preserveAspectRatio="none"
            aria-hidden="true"
        >
            <line x1="748" y1="0" x2="628" y2="900" stroke="#FDB927" strokeWidth="1" strokeOpacity="0.28" />
            <line x1="752" y1="0" x2="632" y2="900" stroke="rgba(6,78,87,0.08)" strokeWidth="1" />
        </svg>

        {/* Mobile — bottom stage */}
        <div
            className="pointer-events-none absolute inset-x-0 bottom-0 h-[min(42vh,380px)] min-h-[260px] lg:hidden"
            style={{ clipPath: "polygon(0 16%, 100% 0, 100% 100%, 0 100%)" }}
            data-testid="hero-split-panel-mobile"
        >
            <div className="absolute inset-0 bg-gradient-to-t from-brand-mist via-brand-surface/95 to-brand-surface/40" />
            <div className="bg-blueprint-hero absolute inset-0 opacity-70" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_90%_80%_at_50%_100%,rgba(6,78,87,0.06)_0%,transparent_70%)]" />

            <svg className="absolute inset-0 h-full w-full" viewBox="0 0 640 380" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
                <path
                    d="M 40 300 C 160 220, 280 180, 420 140 S 560 80, 600 60"
                    fill="none"
                    stroke="#FDB927"
                    strokeWidth="1.5"
                    strokeOpacity="0.4"
                    strokeLinecap="round"
                    strokeDasharray="0.5 14"
                />
                <CORNER_BRACKET x={24} y={52} />
                <CORNER_BRACKET x={616} y={52} flipX />
            </svg>

            <HeroFloorPlan variant="stage" />

            <img
                src="/brand/genie.png"
                alt=""
                className="absolute bottom-6 right-6 w-[clamp(72px,18vw,108px)] opacity-[0.12]"
            />
        </div>
    </>
);
